import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { store } from './presentation/store'
import { analyticsService } from './domain/services/analytics/analyticsService'
import { installGlobalErrorHandlers } from './domain/services/analytics/globalErrorHandlers'

// Register analytics user-id resolution and global error capture before
// React mounts so startup errors in providers/routing are captured. The
// provider closure reads `firebaseUserId` from the store on every log call,
// so auth transitions are picked up without re-registration.
analyticsService.setUserIdProvider(() => store.getState().auth.firebaseUserId)
installGlobalErrorHandlers()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)